import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: #000000;
  padding: 2.5rem 0;
`;

export const Title = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #ffffff;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #8e6adf;
  }
`;

export const Extra = styled.section`
  background-color: #000000;
  color: #ffffff;
  padding-top: 1%;
  position: relative;
  z-index: 10;

  @media screen and (max-width: 768px) {
    padding: 1rem 0;
    margin-top: auto;
  }

  .max-w-6xl {
    max-width: 1280px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-top: 1px solid #444444;
    align-items: top;
    padding: 0.5% 0;

    @media screen and (max-width: 768px) {
      padding: 1rem 0;
      flex-direction: column;
      gap: 0.5rem;
    }
  }

  .footer-section {
    text-align: left;
    padding-left: 1%;
    display: flex;
    align-items: left;
    flex-direction: column;
    padding: 0;
  }

  .Copyright {
    font-size: 16px;
    color: #ffffff;
    text-decoration: none;
    font-weight: bold;
  }

  .icp-link {
    font-size: 8px;
    color: #cccccc;
    text-decoration: none;
  }

  .icp-link-black {
    font-size: 8px;
    color: #cccccc;
    text-decoration: none;
  }

  .back-to-top {
    display: flex;
    justify-content: center;
    align-items: top;
    text-decoration: none;
    cursor: pointer;
    color: #cccccc;
    padding: 10px;
    width: 100%;
    background: none;
    border: none;

    &:hover {
      color: #ffffff;
      text-decoration: underline;
    }

    @media screen and (max-width: 768px) {
      padding: 0.5rem;
      font-size: 14px;
    }
  }

  .right-section {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 1%;

    a {
      color: #ffffff;
      text-decoration: none;

      &:hover {
        color: #cccccc;
        text-decoration: underline;
      }
    }
  }
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  color: #cccccc;
  font-size: 14px;
  width: 70%;
`;

export const Large = styled(Link)`
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-transform: capitalize;
  line-height: 24px;
  display: block;
  margin-bottom: 0.625rem;
  transition: all 0.3s ease-in-out;
  max-width: max-content;

  &:hover {
    color: #8e6adf;
    text-underline-position: under;
    text-decoration: #8e6adf wavy underline;
  }
`;

export const Chat = styled("p")`
  color: #cccccc;
  max-width: fit-content;
  border-bottom: 1px solid #cccccc;
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    border-bottom: 1px solid #8e6adf;
    color: #8e6adf;
  }
`;

export const Empty = styled("div")`
  position: relative;
  height: 53px;
`;

export const FooterContainer = styled("div")`
  max-width: 510px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  transition: all 0.1s ease-in-out;

  a {
    &:hover,
    &:active,
    &:focus {
      -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
      transform: scale(1.1);
    }
  }

  @media screen and (max-width: 769px) {
    width: auto;

    a:not(:last-child) {
      display: none;
    }
  }

  div {
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;

    &:hover {
      fill: rgb(255, 130, 92);
    }
  }
`;

export const Language = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #ffffff;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const Label = styled("label")`
  font-size: 22px;
  text-transform: capitalize;
  color: #ffffff;
  display: block;
  margin-bottom: 2rem;
  font-family: "Motiva Sans Bold", serif;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
    margin-bottom: 1rem;
  }
`;

export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;


export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 85px;
`;

export const FooterStyle = styled("div")`
  background-color: #000000;
  color: #ffffff;
  padding-top: 1%;
`;

export const MaxWidthContainer = styled("div")`
  max-width: 1280px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-top: 1px solid #444444;
  align-items: top;
  padding: 0.5% 0;
`;

export const FooterSectionStyled = styled("div")`
  text-align: left;
  padding-left: 1%;
  display: flex;
  align-items: left;
  flex-direction: column;
  padding: 0;
`;

export const Copyright = styled("span")`
  font-size: 16px;
  color: #ffffff;
  text-decoration: none;
  font-weight: bold;
`;

export const IcpLink = styled("a")`
  font-size: 8px;
  color: #cccccc;
  text-decoration: none;
`;

export const IcpLinkBlack = styled(IcpLink)`
  color: #cccccc;
`;

export const BackToTop = styled("a")`
  display: flex;
  justify-content: center;
  align-items: top;
  text-decoration: none;
  cursor: pointer;
  color: #cccccc;
  padding: 10px;
  width: 100%;

  &:hover {
    color: #ffffff;
    text-decoration: underline;
  }
`;

export const RightSection = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 1%;

  a {
    color: #ffffff;
    text-decoration: none;

    &:hover {
      color: #cccccc;
      text-decoration: underline;
    }
  }
`;




